import React, {useState, useEffect, Dispatch, SetStateAction} from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import {Box, Button, Menu, Select, MenuItem, IconButton} from '@mui/material';
import {emphasize, styled} from '@mui/material/styles';
import HomeIcon from '@mui/icons-material/Home';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MenuWithSearch from './Menusearch';
import FileThumbnail from 'src/minimal-components/file-thumbnail/file-thumbnail';
import FormConstants from '@shared/constants/FormConstants';
import AuthUtils from 'src/utils/AuthUtils';
import {useModuleContext} from '@context/ModuleContext';
import {useAppContext} from '@context/AppContext';
import {
  AI_BLOB_SEARCH,
  BASE_MENU_ITEM,
  BASE_RECORD_ID
} from 'src/routes/BaseRoute';
import EncryptUtils from 'src/utils/EncryptUtils';
import {useSnackbar} from 'notistack';
import {
  getDocumentsHierarchyData,
  getFilesContent
} from '@shared/services/service-handlers/PrivateService';
import {getErrorMessage} from '@shared/utils/ErrorUtils';
import SnackBarConfig from '@components/snackbar/SnackbarConfig';

// Utility function from above

interface Document {
  ID: number | string;
  LegacyApp: string;
  LegacyMRN: string;
  SourceDocumentID: string;
  ParentDocumentTypeID?: null | number;
  FileExtensions: string[];
  IsNotes: boolean[];
  Name: string;
  Description: string;
  IsActive: boolean;
  FULL_PATH: string;
  ALPHA_SEQ_PATH: string;
  order: number;
  IsMultiPage: string;
  Sequence: number[];
  DocumentTypeID: number;
  ChildNodes?: any[];
  Code?: string;
  HasDocuments?: boolean;
  Count?: number;
  ConnectionStrings?: any[];
  Containers?: any[];
  AccountNumber?: string | null;
  EncounterNumber?: string | null;
  EncounterDate?: string | null;
  PrescriptionNumber?: string | null;
  PrescriptionDate?: string | null;
  DocumentDate?: string | null;
  Owner?: string | null;
  VerifiedBy?: string | null;
  ReviewedBy?: string | null;
  Status?: any;
  SignedBy?: string | null;
  UploadedBy?: string | null;
  Version?: string | null;
  VersionDate?: string | null;
}
interface AppProps {
  documentFolders: any[];
  setDocData: Dispatch<SetStateAction<any>>;
  setDocumentFolders: (data: any[]) => void;
  subModuleUIData: any;
  subModuleData: any;
  module: string;
  sub_module: string;
  patient_id: string | any;
  legacyApp?: string;
  unique_id?: string;
  procedure_type?: string;
  accession_number?: string;
  ParentLegacyValue?: string;
  folder_id?: string;
  date_range?: object;
  rowData?: any;
  height?: any;
  top?: string;
}
function findPathById(
  tree: any,
  targetId: any,
  path: any[] = []
): Document[] | null {
  for (const node of tree) {
    const newPath = [...path, node];
    if (
      node.ID === targetId ||
      (Array.isArray(node.ID) &&
        typeof node.ID[0] === 'object' &&
        node.ID[0] !== null &&
        targetId in node.ID[0])
    ) {
      return newPath;
    }

    if (node.ChildNodes && node.ChildNodes.length) {
      const result = findPathById(node.ChildNodes, targetId, newPath);
      if (result) return result;
    }
  }
  return null;
}
export default function FileCabinetBreadCrumb({
  documentFolders,
  setDocumentFolders,
  subModuleUIData,
  rowData,
  date_range,
  ParentLegacyValue,
  module,
  sub_module,
  patient_id,
  legacyApp,
  unique_id,
  setDocData
}: AppProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const {
    appState: {applicationName}
  } = useAppContext();
  const {moduleState} = useModuleContext();
  const {isBH, isBHReason}: any = moduleState;
  const recordId = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_RECORD_ID
  );

  const aiBlobSearch = EncryptUtils.getDecryptedData(
    location?.search,
    AI_BLOB_SEARCH
  );
  const [selectedFolder, setSelectedFolder]: any = useState({isLoaded: false});
  const menuItem = new URLSearchParams(location?.search).get(BASE_MENU_ITEM);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const {enqueueSnackbar} = useSnackbar();
  const getLocaleStorageData = AuthUtils.getSelectedCheckBoxData();
  const [currentNodeId, setCurrentNodeId] = useState(documentFolders[0].ID);
  const [showSelect, setShowSelect] = useState(false);
  const {
    documents_versions_sql: documentVersionSQL,
    document_version_data_sql: documentVersionDataSQL,
    document_data_sql: documentDataSql,
    document_folders_sql: documentFolderSql,
    legit_documents_folders_sql: legitDocumentsFoldersSql,
    documents_count_sql: documentsCountSql,
    document_folders_contents: folderContentsQuery,
    filter_schema_clause: filterSchemaClause,
    variables,
    actions,
    // show_checkbox: showCheckbox,
    hide_document_viewer: hideDocumentViewer
  } = subModuleUIData;
  // Find the path to the current node
  const path = findPathById(documentFolders, currentNodeId) || [
    documentFolders[0]
  ];
  const currentNode = path[path.length - 1];

  // Children for the Select dropdown
  const children = currentNode.ChildNodes || [];
  const childrensCount = currentNode.COUNTS || 0;

  const handleBreadcrumbClick = (idx: number) => {
    // setSelectedFolder((prevState: any) => {
    //   return {
    //     ...prevState,
    //     Folder_ID: path[idx].ID,
    //     isLoaded: true
    //   };
    // });
    setCurrentNodeId(path[idx].ID);
    setShowSelect(false);
  };

  const handleExpandClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget as HTMLElement);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const normalizeArrayFields = (obj: Record<string, any>) => {
    const result: Record<string, any> = {};

    for (const [key, value] of Object.entries(obj)) {
      if (
        typeof value === 'string' &&
        value.startsWith('[') &&
        value.endsWith(']')
      ) {
        try {
          const parsed = JSON.parse(value);
          result[key] = Array.isArray(parsed)
            ? parsed
            : parsed.split(',').map((e: string) => e.trim());
        } catch {
          // fallback if JSON.parse fails
          if (value.startsWith('[') && value.endsWith(']')) {
            const inner = value.slice(1, -1); // remove [ and ]
            result[key] = inner
              .split(',')
              .map(e => e.trim().replace(/^"|"$/g, ''));
          } else {
            result[key] = value;
          }
        }
      } else {
        result[key] = value;
      }
    }

    return result;
  };

  // Example menu option handler
  const handleMenuSelect = (childId: any) => {
    // navigate to childId here
    const normalized = normalizeArrayFields(childId);
    if (normalized.FileExtensions !== null) {
      setDocData(normalized);
    }
    setCurrentNodeId(childId.ID);
    setAnchorEl(null);
  };

  const updateDocumentFolders = (
    updater: (folders: any[]) => any[] | void
  ): void => {
    const clonedTree = JSON.parse(JSON.stringify(documentFolders));
    const updatedTree = updater(clonedTree) || clonedTree;
    setDocumentFolders(updatedTree);
  };
  return (
    <Box
      sx={{
        p: 1,
        borderRadius: 2,
        width: '100%',
        backgroundColor: '#fff',
        transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        color: '#212B36',
        mb: 1,
        boxShadow:
          '0px 3px 5px -1px rgba(145, 158, 171, 0.2),0px 5px 8px 0px rgba(145, 158, 171, 0.14),0px 1px 14px 0px rgba(145, 158, 171, 0.12)'
      }}>
      <Breadcrumbs aria-label="breadcrumb" sx={{mb: 0.5}}>
        {path.map(
          (
            node: {
              ID: React.Key | null | undefined;
              Name: string;
              FileExtensions: string | string[] | null;
            },
            idx: number
          ) => {
            const {FileExtensions: rawExtensions} = node;
            let fileExtensions: string[] = [];
            if (Array.isArray(rawExtensions)) {
              fileExtensions = rawExtensions;
            } else if (typeof rawExtensions === 'string') {
              try {
                // Try JSON.parse first
                const parsed = JSON.parse(rawExtensions);
                if (Array.isArray(parsed)) {
                  fileExtensions = parsed;
                } else {
                  fileExtensions = rawExtensions
                    .split(',')
                    .map((e: string) => e.trim());
                }
              } catch {
                // Fallback to comma split
                if (
                  rawExtensions.startsWith('[') &&
                  rawExtensions.endsWith(']')
                ) {
                  const inner = rawExtensions.slice(1, -1); // remove [ and ]
                  fileExtensions = inner
                    .split(',')
                    .map(e => e.trim().replace(/^"|"$/g, ''));
                } else {
                  fileExtensions = rawExtensions.split(',').map(e => e.trim());
                }
              }
            }
            const fileType =
              fileExtensions !== null && fileExtensions.length > 0
                ? fileExtensions[0]?.toLowerCase()
                : '';
            const type = !fileExtensions?.length
              ? 'folder'
              : fileExtensions?.length > 1
                ? 'multi'
                : fileType;
            return idx < path.length - 1 ? (
              <Link
                key={node.ID}
                underline="hover"
                color="inherit"
                onClick={() => handleBreadcrumbClick(idx)}
                sx={{cursor: 'pointer', display: 'flex'}}>
                <FileThumbnail
                  tooltip={true}
                  file={type || ''}
                  sx={{width: 15, height: 15, mr: '5px'}}
                />
                {node.Name}
              </Link>
            ) : (
              <Button
                key={node.ID}
                endIcon={type === 'folder' ? <ExpandMoreIcon /> : null}
                onClick={
                  type === 'folder'
                    ? e => {
                        handleExpandClick(e);
                        setSelectedFolder((prevState: any) => {
                          return {
                            ...prevState,
                            Folder_ID: node.ID,
                            isLoaded: true
                          };
                        });
                      }
                    : undefined
                }
                sx={{
                  color: 'text.primary',
                  background: 'none',
                  boxShadow: 'none',
                  padding: 0,
                  minWidth: 'unset',
                  fontWeight: 400
                }}
                disableRipple>
                <FileThumbnail
                  tooltip={true}
                  file={type || ''}
                  sx={{width: 15, height: 15, mr: '5px'}}
                />
                {node.Name}
              </Button>
            );
          }
        )}
      </Breadcrumbs>
      <MenuWithSearch
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        handleClose={handleClose}
        setDocumentFolders={setDocumentFolders}
        updateDocumentFolders={updateDocumentFolders}
        setSelectedFolder={setSelectedFolder}
        selectedFolder={selectedFolder}
        // eslint-disable-next-line react/no-children-prop
        children={children}
        childrensCount={childrensCount}
        handleMenuSelect={handleMenuSelect}
        documentFolders={documentFolders}
        currentFolder={currentNode}
        setDocData={setDocData}
        subModuleUIData={subModuleUIData}
        subModuleData={[]}
        module={module}
        sub_module={'null'}
        patient_id={''}
        legacyApp={ParentLegacyValue}
        unique_id={''}
        ParentLegacyValue={ParentLegacyValue}
        date_range={date_range}
      />
      {/* <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {children.map((child) => (
          <MenuItem
            key={child.ID}
            onClick={() => handleMenuSelect(child.ID)}
          >
            {child.Name}
          </MenuItem>
        ))}
      </Menu> */}
      {/* <RHFAutocomplete
                name="autocomplete"
                label="Autocomplete"
                options={children}
                getOptionLabel={(option) => option.label}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                renderOption={(props, option) => (
                  <li {...props} key={option.value}>
                    {option.label}
                  </li>
                )}
              /> */}
    </Box>
  );
}
